import styled from 'styled-components/macro';

const Container = styled.div`
  margin: 20px 0px;
`;

const ContactItem = styled.div`
  margin-bottom: 8px;
`;

const ContactSubItem = styled.div`
  font-size: 14px;
`;

const ContactInformation = styled.div`
  margin-top: 20px;
`;

export const ContactInfo = (
  <Container>
    <ContactItem>
      Caixa Seguradora:{" "}
      <a href="tel:08002743000">
        0800 274 3000
      </a>
    </ContactItem>

    <ContactItem>
      Youse:{" "}
      <a href="tel:08007309991">
        0800 730 9991
      </a>
    </ContactItem>

    <ContactItem>
      Atendimento ao surdo:{" "}
      <a href="tel:08007024260">
        0800 702 4260
      </a>

      <ContactSubItem>
        <span>Ligue usando um aparelho adaptado com teclado alfanumérico.</span>
      </ContactSubItem>
    </ContactItem>

    <ContactInformation>
      <strong>Horário de atendimento</strong>: de segunda a sexta-feira, das 8h às
      18h, exceto feriados nacionais.
    </ContactInformation>

  </Container>
);
